import React from 'react'
import { Modal, ModalHeader } from 'pobble-components/dist/modal'
import GroupsComponent from './groups-component/groups-component.container'

const GroupsModal = ({ classes, isOpen, requestClose, onSubmit }) => (
  <Modal isOpen={isOpen} closeButton requestClose={requestClose}>
    <ModalHeader>Filter by groups</ModalHeader>
    <GroupsComponent />
  </Modal>
)

export default GroupsModal
